module.exports = __webpack_public_path__ + "img/bmbf_logo_white.6a5894f9.png";